import React from 'react';
import { Check } from '@phosphor-icons/react';
import './ProgressIndicator.css';

const STEPS = [
  { id: 'identification', label: 'Your Info' },
  { id: 'vehicle', label: 'Vehicle' },
  { id: 'service', label: 'Service' },
  { id: 'datetime', label: 'Date & Time' },
  { id: 'confirmation', label: 'Confirm' }
];

export function ProgressIndicator({ currentStep, completedSteps = [] }) {
  const currentIndex = STEPS.findIndex(s => s.id === currentStep);

  return (
    <div className="progress-indicator">
      <div className="progress-indicator__track">
        {STEPS.map((step, index) => {
          const isCompleted = completedSteps.includes(step.id);
          const isCurrent = step.id === currentStep;
          const isPast = index < currentIndex;
          const circleModifier = isCurrent
            ? ' progress-indicator__circle--current'
            : isPast || isCompleted
              ? ' progress-indicator__circle--done'
              : '';

          return (
            <React.Fragment key={step.id}>
              <div className="progress-indicator__step">
                <div className={`progress-indicator__circle${circleModifier}`}>
                  {isPast || isCompleted ? <Check size={20} /> : <span>{index + 1}</span>}
                </div>
                <span className="progress-indicator__label">{step.label}</span>
              </div>

              {index < STEPS.length - 1 && (
                <div
                  className={`progress-indicator__connector${
                    index < currentIndex ? ' progress-indicator__connector--done' : ''
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
